import { gql } from '@apollo/client';
import PRODUCT_FAMILY_FRAGMENT from './product-family';

const PRODUCT_FRAGMENT = gql`
  fragment BaseProduct on Product {
    id
    code
    name
    type
    gradeLevel
    trialAvailable
    iconUrl
    bannerUrl
    family {
      ...BaseProductFamily
    }
  }
  ${PRODUCT_FAMILY_FRAGMENT}
`;

export default PRODUCT_FRAGMENT;
